import HttpClient, { IResponseModel } from "../HttpClient";
import {
  ICarrierConfig,
  IContainerType,
  TThumbnailPositionEnum,
} from "@tedivo/tedivo-textures-services-pure";
import {
  ITextureCarrierData,
  ITexturePrefixData,
} from "@tedivo/tvd-api-models";

const texturesBaseUrl = "/admin/textures";

const TexturesService = {
  getConfigAll: async (): Promise<IResponseModel<ITextureCarrierData[]>> => {
    const client = new HttpClient();
    return await client.request<ITextureCarrierData[]>({
      method: "GET",
      url: `${texturesBaseUrl}/carriersConfigs`,
    });
  },

  getPrefixesUse: async (): Promise<IResponseModel<ITexturePrefixData[]>> => {
    const client = new HttpClient();
    return await client.request<ITexturePrefixData[]>({
      method: "GET",
      url: `${texturesBaseUrl}/prefixesUse`,
    });
  },

  saveCarrierAndAliases: async (data: {
    carrier: string;
    aliases: string;
    usesSizes: string;
  }): Promise<IResponseModel<{ carrier: string }>> => {
    const client = new HttpClient();
    return await client.request<{ carrier: string }>({
      method: "PUT",
      url: `${texturesBaseUrl}/carrierAndAliases`,
      data,
    });
  },

  saveCarrierConfig: async (
    data: {
      carrier: string;
    } & ICarrierConfig,
  ): Promise<IResponseModel<{ carrier: string }>> => {
    const client = new HttpClient();
    return await client.request<{ carrier: string }>({
      method: "PUT",
      url: `${texturesBaseUrl}/saveCarrierConfig`,
      data,
    });
  },

  saveCarrierTexture: async (
    data: IRenderContainerInputTxt,
  ): Promise<IResponseModel<{ carrier: string }>> => {
    const client = new HttpClient(undefined, {}, 59000);
    return await client.request<{ carrier: string }>({
      method: "PUT",
      url: `${texturesBaseUrl}/saveTexture`,
      data,
    });
  },

  saveCarrierThumbs: async (
    data: IRenderContainerInputThmbs,
  ): Promise<IResponseModel<{ carrier: string }>> => {
    const client = new HttpClient(undefined, {}, 59000);
    return await client.request<{ carrier: string }>({
      method: "PUT",
      url: `${texturesBaseUrl}/saveThumbs`,
      data,
    });
  },

  deleteCarrierAndAliases: async (
    carrier: string,
  ): Promise<IResponseModel<{ carrier: string }>> => {
    const client = new HttpClient();
    return await client.request<{ carrier: string }>({
      method: "DELETE",
      url: `${texturesBaseUrl}/carrierAndAliases/${carrier}`,
    });
  },
};

export default TexturesService;

interface IRenderContainerInputTxt {
  carrier: string;
  containerType: IContainerType;
  imageBase64Url: string;
}

interface IRenderContainerInputThmbs {
  carrier: string;
  containerType: IContainerType;
  thumbsBase64UrlsObj:
    | Partial<Record<TThumbnailPositionEnum, string>>
    | undefined;
}
